import SwipeableDrawer, { SwipeableDrawerProps } from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material";
import { shadowSmall } from "src/styles/components/constants";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { senecColors } from "src/styles/senecBaseThemePalette";

export interface DrawerStyle {
    drawerPaddingWide: string;
    drawerPaddingModerate: string;
    drawerPaddingNarrow: string;
    modalWidth: string;
    modalMinWidth: string;
    borderRadius: string;
}

export const desktopStyle: DrawerStyle = {
    drawerPaddingWide: "1.5rem", // 32px
    drawerPaddingModerate: "1.5rem", // 24px
    drawerPaddingNarrow: "1rem", // 16px
    modalWidth: "30rem", // 480px
    modalMinWidth: "320px",
    borderRadius: "0",
};

export const mobileStyle: DrawerStyle = {
    drawerPaddingWide: "1rem", // 16px
    drawerPaddingModerate: "1rem", // 16px
    drawerPaddingNarrow: "1rem", // 16px
    modalWidth: "100%",
    modalMinWidth: "320px",
    borderRadius: "0.75rem 0.75rem 0 0",
};

export interface StyledDrawerProps extends SwipeableDrawerProps {
    drawerWidth?: string;
    drawerMinWidth?: string;
    theme: SenecFPPTheme;
}

export const StyledDrawer = styled(SwipeableDrawer, {
    shouldForwardProp: (prop) => prop !== "drawerWidth" && prop !== "drawerMinWidth",
})<StyledDrawerProps>(({ theme, drawerWidth, drawerMinWidth }) => {
    const mobileOffsetTop = 60;

    return {
        "& .MuiDrawer-paper": {
            boxShadow: shadowSmall,
        },
        "& .MuiDrawer-paperAnchorRight, & .MuiDrawer-paperAnchorBottom": {
            marginTop: 0,
            top: 0,
            height: "100%",
            borderRadius: desktopStyle.borderRadius,
            width: drawerWidth ?? desktopStyle.modalWidth,
            minWidth: drawerMinWidth ?? desktopStyle.modalMinWidth,
        },
        "& .MuiBackdrop-root.MuiModal-backdrop:not(.MuiBackdrop-invisible)": {
            backgroundColor: senecColors.neutralGray10Transparency70,
        },
        [theme.breakpoints.down("tablet")]: {
            "& .MuiDrawer-paperAnchorRight, & .MuiDrawer-paperAnchorBottom": {
                marginTop: mobileOffsetTop,
                height: `calc(100% - ${mobileOffsetTop}px)`,
                top: 0,
                borderRadius: mobileStyle.borderRadius,
                width: drawerWidth ?? mobileStyle.modalWidth,
                minWidth: drawerMinWidth ?? mobileStyle.modalMinWidth,
            },
        },
    };
});
